module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"myCampaigns":"Meine Aktionen"},"en":{"myCampaigns":"My campaigns"}}')
  delete Component.options._Ctor
}
